import styled, { keyframes } from "styled-components";
import ppsLogo from "../../image/ppsol_new.png";
import ppsLogo_ja from "../../image/locateU.png";

// Main container, centered within the viewport
export const Container = styled.div`
  max-width: 480px;
  margin: 0 auto;
  padding: 0 10px;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 20px;
  }

  @media (max-width: 480px) {
    max-width: 100%;
    padding: 0 15px;
  }
`;

// Updated BackgroundContainer for a more professional, sleek GPS theme
export const BackgroundContainer = styled.div`
  background: linear-gradient(135deg, rgba(245, 248, 252, 1) 0%, rgba(225, 234, 242, 1) 100%);
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 50px;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding-top: 30px;
    align-items: center;
  }

  @media (max-width: 480px) {
    padding-top: 20px;
  }

  &:before {
    content: "";
    position: absolute;
    bottom: -30%;
    left: -30%;
    width: 160%;
    height: 160%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.125), rgba(0, 0, 0, 0.05) 70%, transparent 100%);
    opacity: 0.35;
    box-shadow: 5px 5px 50px rgba(0, 0, 0, 0.1);
  }

  &:after {
    content: "";
    position: absolute;
    top: -30%;
    right: -30%;
    width: 160%;
    height: 160%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.125), rgba(0, 0, 0, 0.05) 70%, transparent 100%);
    opacity: 0.35;
    box-shadow: -5px -5px 50px rgba(0, 0, 0, 0.1);
  }

  &:hover {
    box-shadow: 0 0 60px rgba(0, 123, 255, 0.1), 0 0 40px rgba(255, 255, 255, 0.2);
    transition: box-shadow 0.5s ease;
  }

  transition: all 0.3s ease-in-out;
`;

// Logos
export const PpsLogo = styled.img.attrs({
  src: `${ppsLogo}`,
})`
  width: 180px;
  margin-bottom: 25px;
  border-radius: 8px;
  transition: transform 0.3s ease, filter 0.3s ease;

  &:hover {
    transform: scale(1.05);
    filter: drop-shadow(0 4px 10px rgba(0, 123, 255, 0.3));
  }

  @media (max-width: 768px) {
    width: 150px;
  }

  @media (max-width: 480px) {
    width: 130px;
  }
`;

export const PpsLogoJa = styled.img.attrs({
  src: `${ppsLogo_ja}`,
})`
  width: 180px;
  margin-bottom: 25px;
  border: 2px solid rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.2));
  transition: transform 0.3s ease, filter 0.3s ease;

  &:hover {
    transform: scale(1.05);
    filter: drop-shadow(0 4px 10px rgba(0, 123, 255, 0.3));
  }

  @media (max-width: 768px) {
    width: 150px;
  }

  @media (max-width: 480px) {
    width: 130px;
  }
`;

// Header styling
export const Header = styled.header`
  text-align: center;
  padding-top: 30px;
  margin-bottom: 50px;

  @media (max-width: 768px) {
    padding-top: 20px;
    margin-bottom: 40px;
  }

  @media (max-width: 480px) {
    padding-top: 15px;
    margin-bottom: 30px;
  }
`;

// Title styling
export const Title = styled.h1`
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 15px;
  color: #4b2e2b;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;

  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.3), 
               0px 0px 5px rgba(0, 0, 0, 0.1); 

  @media (max-width: 768px) {
    font-size: 1.8rem;
    margin-bottom: 10px;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
    margin-bottom: 8px;
  }
`;

// Subtitle styling for a clean, elegant look
export const SubTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 400;
  color: #5a3e36;
  letter-spacing: 0.03em;
  line-height: 1.4;
  font-family: "Montserrat", sans-serif;
  max-width: 320px;
  text-align: left;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

// Form styling
export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    gap: 15px;
  }

  @media (max-width: 480px) {
    gap: 10px;
  }
`;

// Input field container to house the icon and input
export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 0 15px;
  transition: border-color 0.3s ease, background-color 0.3s ease;

  @media (max-width: 768px) {
    padding: 0 12px;
  }

  @media (max-width: 480px) {
    padding: 0 10px;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.8);
    border-color: #007bff;
  }

  &:focus-within {
    border-color: #007bff;
    box-shadow: 0 0 8px rgba(0, 123, 255, 0.3);
  }
`;

// Input field styled component with icons
export const InputWithIcon = styled.input`
  width: 100%;
  padding: 14px 0;
  font-size: 1rem;
  background-color: transparent;
  border: none;
  color: #495057; 
  outline: none;

  @media (max-width: 768px) {
    padding: 12px 0;
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    padding: 10px 0;
    font-size: 0.85rem;
  }

  &::placeholder {
    color: #adb5bd;
  }
`;

// Button styling with hover effects
export const StyledButton = styled.button`
  width: 100%;
  padding: 12px 15px;
  font-size: 1rem;
  font-weight: 600;
  color: white;
  background: linear-gradient(to right, #007bff, #0056b3);
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 123, 255, 0.3);
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    background: linear-gradient(to right, #0056b3, #003b7a);
    box-shadow: 0 6px 12px rgba(0, 123, 255, 0.4);
  }

  &:active {
    background-color: #003b7a;
    box-shadow: none;
  }

  @media (max-width: 768px) {
    font-size: 0.95rem;
    padding: 10px 13px;
  }

  @media (max-width: 480px) {
    font-size: 0.85rem;
    padding: 8px 10px;
  }
`;

// Signal wave animation keyframes
const signalWave = keyframes`
  0% {
    opacity: 0.7;
    transform: scale(0.5);
  }
  50% {
    opacity: 0.2;
    transform: scale(1.5);
  }
  100% {
    opacity: 0;
    transform: scale(2);
  }
`;

// Signal wave effect on title click
export const SignalWave = styled.div`
  position: absolute;
  top: -10px;
  right: -30px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #007bff;
  animation: ${signalWave} 2s ease-out infinite;
`;

// Satellite wrapper for positioning
export const SatelliteWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

// Subtitle container with proper alignment
export const IconWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
  color: #adb5bd;
`;
